import React, { useContext } from 'react';
import { $, StarberryComponentContext, Iterator } from '@starberry/components';
import { createSearchUrl, preProcessSearches } from 'core/helpers/search';
import { Icon } from '@chakra-ui/react';

import * as UserObjectActions from 'core/services/store/userobject/actions';
import UserObjectServices from 'core/services/store/userobject/services';

const AddIcon = () => {
  const { constants } = useContext(StarberryComponentContext);

  return <Icon as={constants.icons.add} />;
};

export default {
  $: 'Stack',
  props: {
    spacing: [6, 12],
  },
  provide: ['userobject'],
  data: $('state.userobject.0.savedSearches'),

  children: [
    {
      $: 'Disclosure',
      render:
        () =>
        ({ isOpen, onClose, onOpen }) => {
          return {
            $: 'Flex',
            props: {
              direction: 'column',
            },
            children: [
              {
                $: 'PrimaryButton',
                provide: ['form'],
                leftIcon: AddIcon,
                mb: 4,
                w: 'initial',
                minW: '300px',
                alignSelf: ['auto', null, 'flex-start'],
                onClick: (_, context) => () => {
                  if (!context?.state?.form) {
                    return;
                  }
                  const [, dispatch] = context?.state?.form || [];
                  dispatch({
                    type: 'CHANGE_FORM_STATE',
                    payload: {
                      values: {},
                    },
                  });
                  onOpen();
                },
                children: $(
                  'constants.translations.savedSearch.ADD_SAVED_SEARCH_LABEL',
                  'Add Search'
                ),
              },
              {
                $: 'FormDialog',
                provide: ['userobject'],
                onSubmit: (_, context) => (values) => {
                  const [, dispatch] = context?.state?.userobject || [];
                  const userServices = UserObjectServices(dispatch, UserObjectActions);

                  userServices.createUserobject('savedSearches', {
                    params: values,
                    type: 'search',
                    state: 1,
                  });

                  onClose?.();
                },
                isOpen: isOpen,
                onClose: () => onClose,
                fields: $('constants.forms.createSavedSearch'),
                title: $(
                  'constants.translations.savedSearch.ADD_SAVED_SEARCH_MODAL_TITLE',
                  'Create a new search criteria'
                ),
              },
            ],
          };
        },
    },
    {
      component: Iterator,
      provide: ['userobject'],
      props: {
        data: (_, { state }) => {
          return preProcessSearches(state?.userobject?.[0]?.savedSearches || []);
        },
        limit: 10,
        template: {
          $: 'SearchListItem',
          props: {
            type: 'savedSearches',
            cursor: 'pointer',
            onClick: () => (_, context) => () => {
              if (!context) {
                return;
              }
              const {
                constants,
                data: { params },
              } = context;
              let url = `${constants?.['website-url']}${createSearchUrl(params)}`;
              window.location = url;
            },
          },
        },
        loading: {
          $: 'Spinner',
        },
        empty: {
          $: 'NoContentAvailable',
          icon: 'saveSearchEmpty',
          heading: $(
            'constants.translations.savedSearch.NO_SAVED_SEARCH_TITLE',
            'There are no saved searches'
          ),
          description: $(
            'constants.translations.savedSearch.NO_SAVED_SEARCH_SUBTITLE',
            'Click Add Search to add a new saved search'
          ),
        },
      },
    },
  ],
};
